import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const IesDependentLabels: IntakeLabelCollection = {
  firstName: {
    label: "Child's first name",
  },
  middleName: {
    label: "Child's middle name",
  },
  lastName: {
    label: "Child's last name",
  },
  firstNameAlt: {
    label: 'First name',
  },
  middleNameAlt: {
    label: 'Middle name',
  },
  lastNameAlt: {
    label: 'Last name',
  },
  birthdate: {
    label: 'Birthdate',
  },
  gender: {
    label: 'Gender',
  },
  immigrationStatus: {
    label: 'Citizenship / Immigration status',
  },
  immigrationStatusSponsored: {
    label: 'Is your child sponsored?',
    thirdPersonLabel: 'Is <<personName>> sponsored?',
  },
  livesWithParent: {
    label: 'Does the child live with you?',
    thirdPersonLabel: 'Does <<personName>> live with <<applicantName>>?',
  },
  livesWithApplicant: {
    label: 'Does the child live with you?',
    thirdPersonLabel: 'Does <<personName>> live with <<applicantName>>?',
  },
  parentDeceased: {
    label: 'Is the parent not living in the household deceased?',
  },
  attendingHighSchool: {
    label: 'Is the child attending Grades K-12?',
    thirdPersonLabel: 'Is <<personName>> attending Grades K-12?',
  },
  graduationDate: {
    label: 'Provide the month and year when the child will graduate from high school',
    thirdPersonLabel: 'Provide the month and year when <<personName>> will graduate from high school',
  },
  hasIndianRegistration: {
    label: 'Does the child have an Indian Registration Number?',
    thirdPersonLabel: 'Does <<personName>> have an Indian Registration Number?',
  },
  biologicalChild: {
    spousePartnerLabel:
      'Are you and your <<spouseLabel>> the biological/adoptive parents of all of the child(ren) listed above?',
    thirdPersonLabel:
      'Is <<applicantName>> and <<spouseName>> the biological/adoptive parents of all of the child(ren) listed above?',
    label: '',
  },
  biologicalIndividualChild: {
    spousePartnerLabel: 'Are you and your <<spouseLabel>> the biological or adoptive parents of the child?',
    thirdPersonLabel: 'Is <<applicantName>> and <<spouseName>> the biological or adoptive parents of <<personName>>?',
    label: '',
  },
  whoIsParent: {
    label: `In your household, who is this child's biological/adoptive parent, guardian or caregiver?`,
    thirdPersonLabel: `In your household, who is <<personName>>'s biological/adoptive parent, guardian or caregiver?`,
  },
  parentsMarriedEachOther: {
    label: 'Are/were the parents of the child legally married to each other?',
    thirdPersonLabel: 'Are/were the parents of <<personName>> legally married to each other?',
  },
  parentFirstName: {
    label: 'First Name',
  },
  parentLastName: {
    label: 'Last Name ',
  },
  parentAddress: {
    label: 'Address',
  },

  parentInfoSection: {
    label: 'Information of the parent not living in household',
  },

  parentNameInfoSection: {
    label: 'Name of the parent not living in the household',
  },

  deceasedParentNameInfoSection: {
    label: 'Name of the deceased parent',
  },

  parentAddressInfoSection: {
    label: 'Last known address of parent not living in the household',
  },
};
